import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

// *load ข้อมูลต้นแหล่ง
function* sourceQualityEvaluationDashboardLoadLocation(action) {
  const {
    data: { location_list, location_type, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/get-location`,
      { location_list, location_type },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.sourceQualityEvaluationDashboardLoadLocation.success(res.data)
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationDashboardLoadLocation.failure())
  }
}

// *load ข้อมูลวัตถุดิบ
function* sourceQualityEvaluationDashboardLoadRawMaterial(action) {
  const {
    data: { origin_location_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/get-material-by-origin-location`,
      { origin_location_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.sourceQualityEvaluationDashboardLoadRawMaterial.success(res.data)
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationDashboardLoadRawMaterial.failure())
  }
}

// *load table log ประเมินคุณภาพ
function* sourceQualityEvaluationDashboardLoadTableLog(action) {
  const {
    data: { location_visibility, filterObj, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control/source-quality-control-dashboard`,
      {
        location_visibility,
        filterObj,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.sourceQualityEvaluationDashboardLoadTableLog.success(res.data)
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.sourceQualityEvaluationDashboardLoadTableLog.failure())
  }
}

export default function* watchSourceQualityEvaluationDashboard() {
  yield all([
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_DASHBOARD_LOCATION.REQUEST,
      sourceQualityEvaluationDashboardLoadLocation
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_DASHBOARD_RAW_MATERIAL.REQUEST,
      sourceQualityEvaluationDashboardLoadRawMaterial
    ),
    takeEvery(
      actions.SOURCE_QUALITY_EVALUATION_DASHBOARD_TABLE_LOG.REQUEST,
      sourceQualityEvaluationDashboardLoadTableLog
    ),
  ])
}
export {
  sourceQualityEvaluationDashboardLoadLocation,
  sourceQualityEvaluationDashboardLoadRawMaterial,
  sourceQualityEvaluationDashboardLoadTableLog,
}
